import React from 'react';
import TenantSelector from '@libs/components/TenantSelector';
import ErrorPanel from '../../components/common/ErrorPanel';
import { useTenant } from '@libs/contexts/TenantContext';

// EventSystemLayout component that uses the tenant context
const EventSystemLayout = ({ pageTitle, children, showPageTitle = true }) => {
  const { selectedTenant, loading, error } = useTenant();

  return (
    <div
      style={{
        maxWidth: '100%',
        margin: '0 auto',
        padding: '8px 16px',
      }}
    >
      <div className="mb-2">
        {showPageTitle && (
          <h1 className="text-xl font-bold text-gray-800 mb-2">{pageTitle}</h1>
        )}
        
        <div className="mb-2">
          <TenantSelector />
        </div>
        
        {error && (
          <ErrorPanel 
            title="Error" 
            message={error} 
            variant="error" 
            className="mb-2" 
          />
        )}
        
        {!selectedTenant && !loading && !error && (
          <ErrorPanel
            title="Tenant Selection Required"
            message="Please select a tenant to view data. Contact your administrator if you don't have access to any tenants."
            variant="warning"
            className="mb-2"
          />
        )}
      </div>
      
      {/* Only render children if we have a selected tenant or if we're still loading */}
      {(selectedTenant || loading) && children}
    </div>
  );
};



export default EventSystemLayout;
